import { Icon } from '../regureStyles';

const DataError = ({ fetchDocs }) => {
  return (
    <div
      style={{
        background: '#fef2f2',
        border: '1px solid #fca5a5',
        borderRadius: 8,
        padding: '10px 16px',
        marginBottom: 16,
        fontSize: 13,
        color: '#991b1b',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <Icon name='alert-circle' size={15} color='#ef4444' />
      Could not load documents. Check your connection and{' '}
      <button
        onClick={fetchDocs}
        style={{ background: 'none', border: 'none', color: '#991b1b', cursor: 'pointer', fontWeight: 600, textDecoration: 'underline', padding: 0, fontSize: 13 }}
      >
        retry
      </button>
      .
    </div>
  );
};

export default DataError;
